import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";

import CidadeUfSelect from "components/CidadeUfSelect";
import { MAX_ROTAS, rotaVazia, rotaCompleta } from "./regras";

export { validarCobertura, coberturaParaPayload, coberturaDaApi, rotaVazia, MAX_ROTAS, MIN_ROTAS } from "./regras";

// Editor da cobertura declarada da Rede Everlog (PO1-3648, épico PO1-3359):
// lista de pares origem → destino, cada lado UF ou cidade (CidadeUfSelect).
// Sem preço, sem prazo: a cobertura só diz onde a transportadora atende.
//
// Controlado: `value` é a lista de rotas no formato de regras.js e `onChange`
// recebe a lista nova. Quem valida no submit chama `validarCobertura(value)`;
// aqui a tela só impede passar de 200 e remover a última linha (mínimo 1).
// As funções de carga (`carregarEstados`, `carregarCidades`) vêm por props:
// anônimas na página pública, autenticadas no MeuFrete.

const linhaStyle = {
  display: "grid",
  gridTemplateColumns: "minmax(0, 1fr) auto minmax(0, 1fr) auto",
  gap: "0.6rem",
  alignItems: "start",
  padding: "0.6rem 0.7rem",
  borderRadius: 10,
  border: "1px solid var(--everlog-card-border, rgba(255,255,255,0.15))",
  background: "var(--everlog-card-surface-field, rgba(255,255,255,0.05))",
};
const setaStyle = { alignSelf: "center", fontSize: "1.1rem", opacity: 0.7, paddingTop: "1.4rem" };
const mutedStyle = { fontSize: "0.78rem", opacity: 0.75 };

export default function CoberturaEditor({ value, onChange, carregarEstados, carregarCidades, disabled, erro, max = MAX_ROTAS }) {
  const rotas = Array.isArray(value) && value.length ? value : [rotaVazia()];
  const [estados, setEstados] = useState([]);

  // Uma carga de UFs para todas as linhas.
  useEffect(() => {
    if (typeof carregarEstados !== "function") return undefined;
    let ativo = true;
    Promise.resolve(carregarEstados())
      .then((lista) => {
        if (ativo) setEstados(Array.isArray(lista) ? lista : []);
      })
      .catch(() => {
        if (ativo) setEstados([]);
      });
    return () => {
      ativo = false;
    };
  }, [carregarEstados]);

  const emitir = (lista) => {
    if (onChange) onChange(lista);
  };

  const trocarLado = (i, lado, valor) => {
    emitir(rotas.map((r, idx) => (idx === i ? { ...r, [lado]: valor } : r)));
  };

  const adicionar = () => {
    if (rotas.length >= max) return;
    emitir(rotas.concat([rotaVazia()]));
  };

  const remover = (i) => {
    if (rotas.length <= 1) return;
    emitir(rotas.filter((_, idx) => idx !== i));
  };

  const completas = rotas.filter(rotaCompleta).length;

  return (
    <div data-testid="cobertura-editor">
      <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
        {rotas.map((r, i) => (
          <div key={r.id || `rota-${i}`} style={linhaStyle} data-testid="cobertura-rota">
            <CidadeUfSelect rotulo="Origem" idPrefixo={`rota-${i}-origem`} value={r.origem} estados={estados} carregarCidades={carregarCidades} onChange={(v) => trocarLado(i, "origem", v)} disabled={disabled} />
            <div style={setaStyle} aria-hidden="true">
              →
            </div>
            <CidadeUfSelect rotulo="Destino" idPrefixo={`rota-${i}-destino`} value={r.destino} estados={estados} carregarCidades={carregarCidades} onChange={(v) => trocarLado(i, "destino", v)} disabled={disabled} />
            <Button type="button" size="sm" color="danger" outline onClick={() => remover(i)} disabled={disabled || rotas.length <= 1} title={rotas.length <= 1 ? "Informe pelo menos uma rota" : "Remover rota"} aria-label={`Remover rota ${i + 1}`} style={{ marginTop: "1.4rem" }}>
              ×
            </Button>
          </div>
        ))}
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "0.75rem", marginTop: "0.6rem", flexWrap: "wrap" }}>
        <span style={mutedStyle}>
          {completas} de {rotas.length} rota(s) completa(s) · máximo {max}
        </span>
        <Button type="button" size="sm" color="info" outline onClick={adicionar} disabled={disabled || rotas.length >= max}>
          + Adicionar rota
        </Button>
      </div>
      {erro ? (
        <div role="alert" style={{ color: "#ec250d", fontSize: "0.82rem", marginTop: "0.4rem" }}>
          {erro}
        </div>
      ) : null}
    </div>
  );
}
